<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>用户组</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <el-button
                @click="handleConfirm"
                v-if="Opt !='view'"
              >
                <span>提交</span>
              </el-button>
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
              <el-button
                class="option-btn"
                v-if="false"
                @click="setAction"
              >
                <span>权限设置</span>
              </el-button>
            </div>
          </el-row>
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form
                ref="userGroupInfoRef"
                :model="userGroupInfo"
                :rules="userGroupInfoRules"
                size="small"
                class="singleContent"
                :disabled="Opt == 'view'"
              >
                <el-row :gutter="20">
                  <el-col :span="10">
                    <div class="grid-content">
                      <el-form-item
                        label="代  码:"
                        prop="UserGroupCode"
                      >
                        <el-input
                          v-model="userGroupInfo.UserGroupCode"
                          clearable
                          :disabled="Opt != 'insert'"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="10">
                    <div class="grid-content">
                      <el-form-item
                        label="名称:"
                        prop="UserGroupName"
                      >
                        <el-input
                          v-model="userGroupInfo.UserGroupName"
                          clearable
                        />
                      </el-form-item>
                    </div>
                  </el-col>

                  <el-col :span="10">
                    <div class="grid-content">
                      <el-form-item
                        label="描    述:"
                        prop="BZ"
                      >
                        <el-input
                          v-model="userGroupInfo.BZ"
                          clearable
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="10">
                    <div class="grid-content">
                      <el-form-item
                        label="创建时间:"
                        prop="CreateTime"
                      >
                        <el-date-picker
                          v-model="userGroupInfo.CreateTime"
                          type="datetime"
                          disabled
                        ></el-date-picker>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="10">
                    <div class="grid-content">
                      <el-form-item
                        label="创建人:"
                        prop="CreateUser"
                      >
                        <el-input
                          disabled
                          v-model="userGroupInfo.CreateUser"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="10">
                    <div class="grid-content">
                      <el-form-item
                        label="修改时间:"
                        prop="UpdateTime"
                      >
                        <el-date-picker
                          v-model="userGroupInfo.UpdateTime"
                          type="datetime"
                          disabled
                        ></el-date-picker>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="10">
                    <div class="grid-content">
                      <el-form-item
                        label="修改人:"
                        prop="UpdateUser"
                      >
                        <el-input
                          v-model="userGroupInfo.UpdateUser"
                          disabled
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
    <div>
      <usergroupRight ref="grouprightRef"></usergroupRight>
    </div>
  </div>
</template>

<script>
import { InsertUserGroup, UpdateUserGroup } from "@api/usergroup";
import { toRefs, ref, unref, reactive, onUpdated } from "vue";
import { ElMessage } from "element-plus";
import usergroupRight from "./usergroupRight.vue";
export default {
  name: "usergroupEidt",
  components: { usergroupRight },
  setup(props, content) {
    const userGroupInfoRef = ref();
    let grouprightRef = ref(null);
    const OriginalData = () => {
      return {
        dialogVisible: false,
        Opt: "",
        userGroupInfoRules: {
          UserGroupCode: [
            {
              required: true,
              message: "请输入代码",
              trigger: "blur",
            },
            {
              min: 3,
              max: 5,
              message: "长度在3到5之间",
              trigger: "blur",
            },
          ],
          UserGroupName: [
            {
              required: true,
              message: "名称",
              trigger: "blur",
            },
          ],
        },
        userGroupInfo: {
          id:'',
          UserGroupCode: "",
          UserGroupName: "",
          CreateTime: "",
          CreateUser: "",
          UpdateTime: "",
          UpdateUser: "",
          BZ: "",
        },
      };
    };
    let data = reactive(OriginalData());
    //关闭
    const handleClose = () => {
      data.dialogVisible = false;
      Object.assign(data, OriginalData());
      content.emit("close-dialog");
    };
    //关闭
    const handleCancel = () => {
      handleClose();
    };
    //权限设置
    const setAction = () => {
      grouprightRef.value.initDialog(data.userGroupInfo.UserGroupCode);
    };
    //提交
    const handleConfirm = async () => {
      const form = unref(userGroupInfoRef);
      if (!form) return;
      try {
        form.validate((valid) => {
          if (valid) {
            if (data.Opt == "insert") {
              data.userGroupInfo.UserGroupCode =
                data.userGroupInfo.UserGroupCode.toUpperCase();
              InsertUserGroup(JSON.stringify(data.userGroupInfo))
                .then(function (result) {
                  if (result.status == 200) {
                    ElMessage.success("新增成功！");
                    data.Opt = "view";
                  } else {
                    ElMessage.error("新增失败!" + result.message);
                  }
                })
                .catch(({message}) => {
                  ElMessage.error("新增失败!" + message);
                });
            } else {
              UpdateUserGroup(JSON.stringify(data.userGroupInfo))
                .then(function (result) {
                  if (result.status == 200) {
                    ElMessage.success("修改成功！");
                    data.Opt = "view";
                  } else {
                    ElMessage.error("修改失败!" + result.message);
                  }
                })
                .catch(({message}) => {
                  ElMessage.error("修改失败!" + error);
                });
            }
          }
        });
      } catch (error) {}
    };
    //初始化页面
    const initDialog = (Opt, row) => {
      data.dialogVisible = true;
      data.Opt = Opt;
      if (row) {
        data.userGroupInfo = row;
      }
      if (Opt == "insert") {
        data.userGroupInfo.CreateUser = localStorage.getItem("UserName");
        data.userGroupInfo.CreateTime = new Date();
      } else if (Opt == "update") {
        data.userGroupInfo.UpdateUser = localStorage.getItem("UserName");
        data.userGroupInfo.UpdateTime = new Date();
      }
    };
    onUpdated(() => {
      //清除校验
      const form = unref(userGroupInfoRef);
      if (!form) return;
      form.clearValidate();
    });

    return {
      ...toRefs(data),
      userGroupInfoRef,
      grouprightRef,
      handleClose,
      handleCancel,
      handleConfirm,
      initDialog,
      setAction,
    };
  },
};
</script>

<style lang="scss" scoped>
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}
.singleContent {
  position: relative;
  padding: 0 8px;
}
.singleContent .el-col {
  padding: 0 5px;
  margin-bottom: 10px;
  min-height: 28px;
}
.singleContent .el-form-item--small.el-form-item {
  margin-bottom: 7px;
}
::v-deep .el-form-item__label {
  display: inline-block;
  color: #282828;
  font-size: 12px;
  padding-right: 0px;
  width: 80px;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 28px;
}
.singleContent .el-form-item--small .el-form-item__content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 12px;
  line-height: 28px;
}
.switch-content {
  position: relative;
  margin-top: 6px;
}

.el-row {
  justify-content: space-between;
}

.el-date-editor.el-input {
  width: 100% !important;
}

.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
::v-deep .el-date-editor--datetime {
  width: 100%;
}
</style>
